import {Injectable} from '@angular/core';
import {FordocUser} from '@app/models/form/fordoc-user.model';
import {NgxSecurityService} from 'ngx-security';
import {RoleConst} from '@app/models/role.const';
import {UserUtils} from "@app/shared/util/user.utils";

@Injectable({providedIn: 'root'})
export class Session {

  private USER_STORAGE: string = "MGTFE_USER";
  private ROLE_STORAGE: string = "MGTFE_ROLE";

  public lastErrorDetails: any;
  public lastErrorCode: any;

  constructor(private security: NgxSecurityService) {
  }

  get roles(): string[] {
    return JSON.parse(sessionStorage.getItem(this.ROLE_STORAGE));
  }

  get mainRole(): string {
    if (!sessionStorage.getItem(this.ROLE_STORAGE)) {
      return '';
    }
    const rolesInMemory = JSON.parse(sessionStorage.getItem(this.ROLE_STORAGE));

    const rolesFiltered = UserUtils.getRoleFiltered(rolesInMemory);
    if (rolesFiltered.length > 0) {
      const roleSplitted = rolesFiltered[0].split('/', 3);
      return roleSplitted[1];
    }
    return '';
  }

  set roles(roles: string[]) {
    if (!roles || !roles.length) {
      return;
    }
    sessionStorage.setItem(this.ROLE_STORAGE, JSON.stringify(roles));
  }

  isLogged(): boolean {
    return !!sessionStorage.getItem(this.ROLE_STORAGE);
  }

  get user(): FordocUser {
    return JSON.parse(sessionStorage.getItem(this.USER_STORAGE));
  }

  set user(user: FordocUser) {
    sessionStorage.setItem(this.USER_STORAGE, JSON.stringify(user));
  }

  public hasRole(role: string) {
    if (this.roles != null) {
      return this.roles.some((r: string) => r.toUpperCase() === role);
    } else {
      return false;
    }
  }

  public hasAnyRoles(roles: string[]): boolean {
    return roles
      .map(role => this.hasRole(role))
      .some((authorized) => authorized);
  }

}
